module.exports = __webpack_public_path__ + "static/media/Screen Shot 2021-07-20 at 2.16.18 PM.da04886c.png";